import React from 'react';

import { type UseFieldArrayReturn } from 'react-hook-form';

import { DraggableQuestionList } from '@/features/admin-interview/DraggableQuestionList';
import { type EditInterviewQuestionsFormInputs } from '@/features/admin-interview/schemas';

import { InterviewQuestionCard } from './InterviewCreateQuestionCard';
import { type NewInterviewFormInputs } from './common';

type QuestionCardListProps = {
  formArray:
    | UseFieldArrayReturn<NewInterviewFormInputs, 'questions', 'id'>
    | UseFieldArrayReturn<EditInterviewQuestionsFormInputs, 'questions', 'id'>;
  isEditMode?: boolean;
  onReorder?: () => void;
};

export const QuestionCardList: React.FC<QuestionCardListProps> = ({
  formArray,
  isEditMode = false,
  onReorder,
}) => {
  // Use the draggable list when in edit mode, otherwise use the simple list
  if (isEditMode) {
    return (
      <DraggableQuestionList
        formArray={formArray}
        isEditMode={isEditMode}
        onReorder={onReorder}
      />
    );
  }

  // Fallback to simple list for non-edit mode
  const { fields, remove } = formArray;
  return (
    <>
      {fields.map((field, index) => (
        <InterviewQuestionCard
          key={field.id}
          index={index}
          field={field}
          fieldsLength={fields.length}
          remove={remove}
          isEditMode={isEditMode}
        />
      ))}
    </>
  );
};
